import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-button-primary",
  templateUrl: "./button-primary.component.html",
  styleUrls: ["./button-primary.component.scss"],
})
export class ButtonPrimaryComponent {
  @Input() buttonCaption: string = "Publish";
  @Input() buttonType: string = "submit";
  @Input() buttonClassName: string = "";
  @Input() loaderEnabledFlag: boolean = false;
  @Input() buttonSubmitEnabled: boolean = false;
  @Input() buttonDisabled: boolean = false;
  @Input() btnMinWidth: string = "initial";
  @Input() btnHeight: string = "40px";
  @Output() actionButtonCall = new EventEmitter<any>();

  clickEvent(buttonData: any) {
    this.actionButtonCall.emit(buttonData);
  }
}
